import Typography from '@mui/material/Typography';

import { Sxable } from 'library/types';

export interface SelectLabelProps extends Sxable {
	label: string;
}

export const SelectLabel = ({
	label,
	sx = { paddingTop: 0.25 },
}: SelectLabelProps) => (
	<Typography sx={sx} variant="body2" >
		{label}
	</Typography>
);
